/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, Meta } from "~/foundation/Api";
import { AliaChatQuestion } from "~/foundation/SitecoreContent/generated-types";
import { AliaChatMessage } from "~/foundation/SitecoreContent/generated-types";
import { AliaChatFeedback } from "~/foundation/SitecoreContent/generated-types";
import { AliaChatMessagesRequest } from "~/foundation/SitecoreContent/generated-types";
import { AliaChatMessages } from "~/foundation/SitecoreContent/generated-types";

export const aliaChatServiceMeta: Meta<typeof aliaChatService> = {
	chatQuestion: ["POST", "/api/v1/alia/chat"],
	feedbackMessage: ["POST", "/api/v1/alia/feedback"],
	messages: ["POST", "/api/v1/alia/messages"],
};

// Foundation.SitecoreContent.WebApi.Alia.AliaChatApiController
export const aliaChatService = {
	async chatQuestion(body: AliaChatQuestion) {
		return await http.fetch<AliaChatMessage, AliaChatQuestion>(aliaChatServiceMeta.chatQuestion, { body });
	},
	async feedbackMessage(body: AliaChatFeedback) {
		return await http.fetch<undefined, AliaChatFeedback>(aliaChatServiceMeta.feedbackMessage, { body });
	},
	async messages(body: AliaChatMessagesRequest) {
		return await http.fetch<AliaChatMessages, AliaChatMessagesRequest>(aliaChatServiceMeta.messages, { body });
	},
};
